import RemoteEvaluator from "../../../../mode/remote/RemoteEvaluator"
import { EvaluatorContext } from "../../../../evaluator/Evaluator"
import EvaluateRequest from "../../../../EvaluateRequest"
import ExperimentRemoteEvaluateRequest from "./ExperimentRemoteEvaluateRequest"
import ExperimentEvaluateResponse from "../../ExperimentEvaluateResponse"
import EvaluationEventRecorder from "../../../../event/EvaluationEventRecorder"
import ExperimentEvaluator from "../../ExperimentEvaluator"

export default class ExperimentRemoteEvaluator
  extends RemoteEvaluator<ExperimentRemoteEvaluateRequest, ExperimentEvaluateResponse>
  implements ExperimentEvaluator<ExperimentRemoteEvaluateRequest>
{
  constructor(private readonly eventRecorder: EvaluationEventRecorder) {
    super()
  }

  supports(request: EvaluateRequest): request is ExperimentRemoteEvaluateRequest {
    return request instanceof ExperimentRemoteEvaluateRequest
  }

  protected remoteEvaluate(
    request: ExperimentRemoteEvaluateRequest,
    context: EvaluatorContext
  ): ExperimentEvaluateResponse {
    // The server-resolved entity is also the result of the evaluation.
    return ExperimentEvaluateResponse.of(request, context, request.entity)
  }

  record(_request: ExperimentRemoteEvaluateRequest, response: ExperimentEvaluateResponse): void {
    this.eventRecorder.record(response)
  }
}
